var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({attrs:{"loading":_vm.isLoading,"color":"info","icon":""},on:{"click":_vm.generateReport}},Object.assign({}, tooltip)),[_c('v-icon',[_vm._v(" fa-file-pdf ")])],1)]}}])},[_c('span',[_vm._v("Descargar reporte")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }